export const SET_CALLCENTER = "setCallcenter";

// Stammdaten
export const SET_TERMINE = "setTermine";
export const SET_BEHANDLUNGSARTEN = "setBehandlungsarten";
export const SET_MITARBEITER = "setMitarbeiter";
export const SET_KOSTENUEBERNAHMEN = "setKostenubernahmen";

// Adressdaten
export const SET_LAENDER = "setLaender";

// Termin-Daten
export const SET_START_DATE = "setStartDate";

export const SET_BESTANDSPATIENT = "setBestandspatient";
export const SET_BEHANDLUNG = "setBehandlung";
export const SET_BEHANDLUNGSART = "setBehandlungsart";
export const SET_PRAXIS = "setPraxis";
export const SET_BEHANDLER = "setBehandler";
export const SET_SELECTED_DAY = "setSelectedDay";
export const SET_SELECTED_ROW = "setSelectedRow";
export const SET_SELECTED_PROPOSALS = "setSelectedProposals";
export const SET_SELECTED_TERMIN = "setSelectedTermin";
export const SET_KOSTENUEBERNAHME = "setKostenuebernahme";
export const SET_KOSTENUEBERNAHME_FINAL = "setKostenuebernahmeFinal";
export const SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN = "setBehandlerauswahlUebersprungen";

export const SET_BOOKED_AT = "setBookedAt";

// Terminverschiebung
export const SET_ACTUAL_TERMIN = "setActualTermin";
export const SET_PATIENT = "setPatient";

// BP
export const SET_ANZAHLUNG = "setAnzahlung";
export const SET_REFERENCE = "setReference";
export const SET_VORGANGSNUMMER = "setVorgangsnummer";


// Patientendaten
export const SET_HASHED_ID = "set_hashed_id";
export const SET_ANREDE = "setAnrede";
export const SET_VORNAME = "setVorname";
export const SET_NAME = "setName";
export const SET_GEBURTSDATUM = "setGeburtsdatum";
export const SET_ADR_STRASSE = "setAdrStrasse";
export const SET_ADR_STRASSENR = "setAdrStrasseNr";
export const SET_ADR_PLZ = "setAdrPlz";
export const SET_ADR_ORT = "setAdrOrt";
export const SET_ADR_LAND = "setAdrLand";
export const SET_TELEFONNUMMER = "setTelefonnummer";
export const SET_MAILADRESSE = "setMailadresse";
export const SET_FREITEXT = "setFreitext";
export const SET_BENACHRICHTIGUNGEN = "setBenachrichtigungen";
export const SET_AGB = "setAgb";

export const SET_CODE = "setCode";

// Loading-Spinner
export const API_START_LOADING = "startLoading";
export const API_FINISH_LOADING = "finishLoading";


export const SET_PAGE = "setPage";
